import React from 'react';
import errorImage from './../../src/images/img-error@2x.png';
const DEFAUT_ERROR_MESSAGE =
  '大変申し訳ございません。指定されたページで技術的な問題が発生しております。Buildee管理者にお問い合わせ下さい。';

export class Error500 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const error = sessionStorage.getItem('print_error');
    sessionStorage.removeItem('print_error');
    return (
      <article className='error'>
        <div className='error__body'>
          <div className='error__title'>内部サーバーエラー</div>
          <div className='error__image'>
            <img src={errorImage} alt='' />
          </div>
          <p className='error__message'>
            {error ? error : DEFAUT_ERROR_MESSAGE}
          </p>
          <div className='error__button'>
            <a href='javascript:history.go(-2);' className='btn--sub'>
              戻る
            </a>
          </div>
        </div>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Error500.jsx